<app-skill-builder-select-list
	[mainTitle]="data?.highlight"
	[custom]="custom"
	[subTitle]="page.subTitle"
	[options]="options"
	[next]="next"
>
</app-skill-builder-select-list>
